import { Component, OnInit, isDevMode } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DueForService } from '../../../../../enums/due-for-service.enum';
import { DashboardService } from '../../../../../services/dashboard.service';
import { HelpersService } from '../../../../../services/helpers.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddEditUserComponent } from '../../../../modals/add-edit-user/add-edit-user.component';
import { CyclistService } from '../../../../../services/cyclist.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-due-for-service-detail',
  templateUrl: './due-for-service-detail.component.html',
  styleUrls: ['./due-for-service-detail.component.scss'],
})
export class DueForServiceDetailComponent implements OnInit {
  public partnerId: any;
  public title: string = '';
  public description: string = '';
  public loading: boolean = false;
  public data: any = [];
  public distanceMetric = 'km';
  public columns: any = [
    {
      header: this.translate.instant('general.headers.name'),
      field: 'Name',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.surname'),
      field: 'Surname',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.email'),
      field: 'Email',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.phone'),
      field: 'PhoneNumber',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.manufacturer'),
      field: 'Manufacturer',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.model'),
      field: 'Model',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.distance'),
      field: 'Mileage',
      type: 'distance',
    },
    {
      header: this.translate.instant('general.headers.hours'),
      field: 'RideHours',
      type: 'hrs',
    },
    {
      header: this.translate.instant('general.headers.last_service'),
      field: 'LastService',
      type: 'date',
    },
  ];
  public devMode: boolean = true;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public dashboardService: DashboardService,
    public helpersService: HelpersService,
    public modalService: NgbModal,
    public cyclistService: CyclistService,
    private translate: TranslateService,
  ) {
    this.partnerId = this.helpersService.getPartnerId();
    this.distanceMetric = this.helpersService.getDistanceMetric();

    if (!isDevMode()) {
      this.devMode = false;
    }
  }

  ngOnInit() {
    this.getRouteInfo();
  }

  getRouteInfo() {
    let routeId = this.route.snapshot.paramMap.get('id');
    switch (routeId) {
      case DueForService.BASED_ON_HOURS:
        this.getDashboardInfoServiceWithinHours();
        this.title = this.translate.instant(
          'bikeshop.due_for_service_detail.based_on_hours_title',
        );
        this.description = this.translate.instant(
          'bikeshop.due_for_service_detail.based_on_hours_description',
        );
        break;
      case DueForService.BASED_ON_KILOMETERS:
        this.getDashboardInfoServiceWithinKm();
        this.title = this.translate.instant(
          'bikeshop.due_for_service_detail.based_on_distance_title',
        );
        this.description = this.translate.instant(
          'bikeshop.due_for_service_detail.based_on_distance_description',
        );
        break;
      case DueForService.BASED_ON_MONTH_INTERVAL:
        this.getDashboardInfoServicedMonthInterval();
        this.title = this.translate.instant(
          'bikeshop.due_for_service_detail.based_on_month_interval_title',
        );
        this.description = this.translate.instant(
          'bikeshop.due_for_service_detail.based_on_month_interval_description',
        );
        break;
    }
  }

  getDashboardInfoServiceWithinHours() {
    this.loading = true;
    this.dashboardService
      .getServiceDueDetail(this.partnerId)
      .subscribe((data) => {
        console.log(data);
        this.data = data.filter((x) => {
          return x.MinuteServiceInterval > 0;
        });
        console.log(this.data);
        this.loading = false;
      });
  }

  getDashboardInfoServiceWithinKm() {
    this.loading = true;
    this.dashboardService
      .getServiceDueDetail(this.partnerId)
      .subscribe((data) => {
        this.data = data.filter((x) => {
          return x.KmServiceInterval > 0;
        });
        this.loading = false;
      });
  }

  getDashboardInfoServicedMonthInterval() {
    this.loading = true;
    this.dashboardService
      .getServiceDueDetail(this.partnerId)
      .subscribe((data) => {
        this.data = data.filter((x) => {
          return x.MonthServiceInterval > 0;
        });
        this.loading = false;
      });
  }

  openCyclist(record) {
    this.cyclistService.getCyclistById(record.UserID).subscribe((cyclist) => {
      const modalRef = this.modalService.open(AddEditUserComponent, {
        size: 'lg',
        backdrop: 'static',
        windowClass: 'user-modal',
      });
      modalRef.componentInstance.partnerId = this.partnerId;
      modalRef.componentInstance.user = cyclist;
      modalRef.componentInstance.cyclistView = true;
      modalRef.componentInstance.singleBike = true;
      modalRef.componentInstance.bikeId = record.BikeID;
      modalRef.result.then(
        (result) => {},
        (onrejected) => {},
      );
    });
  }
}
